"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSiteMapInfo = void 0;
var React = require("react");
var stateless_forms_1 = require("../../logistics/forms/stateless_forms");
var buttons_1 = require("../../buttons");
function getSiteMapInfoFormFields(current_map) {
    return [
        current_map && {
            name: "name",
            label: gettext("Name"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: current_map.name,
        },
    ];
}
function getNewMap(site_id) {
    return {
        id: undefined,
        site: site_id,
        name: gettext("Map"),
        map_width: 0,
        map_height: 0,
        map_url: undefined,
    };
}
var EditSiteMapInfo = function (_a) {
    var site_id = _a.site_id, current_map = _a.current_map, siteMapsSvc = _a.siteMapsSvc;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("h3", null, gettext("Map Information")),
                current_map && (React.createElement(stateless_forms_1.SimpleForm, { fields: getSiteMapInfoFormFields(current_map), onUpdate: function (name, value) {
                        return siteMapsSvc.change_data(current_map.id, name, value);
                    }, valuesObject: current_map })))),
        React.createElement("div", { className: "row" },
            current_map && (React.createElement(React.Fragment, null,
                React.createElement(buttons_1.FileUploadButton, { className: "gamification-sidebar-button", caption: gettext("Upload Image"), uploader: function (content) {
                        return siteMapsSvc.set_map(content, current_map.id);
                    } }),
                React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () {
                        return siteMapsSvc.update(current_map, current_map.id);
                    } }, gettext("Save")),
                React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () { return siteMapsSvc.remove(current_map.id); } }, gettext("Delete")))),
            React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () { return siteMapsSvc.create(getNewMap(site_id)); } }, gettext("Add Map")))));
};
exports.EditSiteMapInfo = EditSiteMapInfo;
